export enum MotorTradeBuySteps {
  Step1 = 'step1',
  Step2 = 'step2',
  Step3 = 'step3',
  Step4 = 'step4',
  Step5 = 'step5',
  Step6 = 'step6',
  Step7 = 'step7',
  Step8 = 'step8',
  Step9 = 'step9',
  Step10 = 'step10',
  Step11 = 'step11',
  Step12 = 'step12',
  Step13 = 'step13',
  Step14 = 'step14',
}

export enum MotorTradeBuyLinks {
  Step1 = '/motortrade-roadrisks/steps/step1',
  Step2 = '/motortrade-roadrisks/steps/step2',
  Step3 = '/motortrade-roadrisks/steps/step3',
  Step4 = '/motortrade-roadrisks/steps/step4',
  Step5 = '/motortrade-roadrisks/steps/step5',
  Step6 = '/motortrade-roadrisks/steps/step6',
  Step7 = '/motortrade-roadrisks/steps/step7',
  Step8 = '/motortrade-roadrisks/steps/step8',
  Step9 = '/motortrade-roadrisks/steps/step9',
  Step10 = '/motortrade-roadrisks/steps/step10',
  Step11 = '/motortrade-roadrisks/steps/step11',
  Step12 = '/motortrade-roadrisks/steps/step12',
  Step13 = '/motortrade-roadrisks/steps/step13',
  Step14 = '/motortrade-roadrisks/steps/step14',
}
